import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import s from './Toaster.module.scss';

function Toaster({
    className = null,
    children, 
    onClick = null, 
    onKeyDown = null,
    onRequestClose = null, 
    show, 
  }) {
  const [isShown, setIsShown] = useState(false);
  const [count, setCount] = useState(0);
  const [mouseIn, setMouseIn] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setMouseIn(true);
    setCount(parseInt(count, 10) + 1);
  }, [count])

  const handleMouseLeave = useCallback(() => {
    setMouseIn(false);
  }, [])

  useEffect(() => {
    if (show) {
      setIsShown(true);
      const timer = setTimeout(() => {
        setIsShown(false);
        return onRequestClose && onRequestClose();
      }, 4000);

      if (mouseIn) {
        clearTimeout(timer);
      }

      return () => clearTimeout(timer);
    }
    return setIsShown(false);
  }, [count, mouseIn, onRequestClose, show]);

  useEffect(() => {
    if (show && !mouseIn && count > 0) {
      const wait = setTimeout(() => {
        setIsShown(false);
        setCount(0);
        return onRequestClose && onRequestClose();
      }, 1000);
      return () => clearTimeout(wait);
    }
    return setCount(count);
  }, [count, mouseIn, onRequestClose, show]);

  return (
    <div
      role="button"
      className={cn(s.container, className, isShown && s.containerShow)}
      aria-label="notification"
      tabIndex={0}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  );
}

Toaster.meta = {
  VERSION: '1.0.0',
};

Toaster.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default Toaster;
